/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import * as configcat from 'configcat-js';
import { AccountService } from '../user/account.service';
import { AnalyticsService } from '../analytics/analytics.service';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class AbTestingService {
  public experimentArray: boolean[] = [];
  private configCatClient: configcat.IConfigCatClient;
  private logger: any;
  private userInfo: any;
  constructor(
    private accountService: AccountService,
    private analyticsService: AnalyticsService
  ) {
    this.logger = configcat.createConsoleLogger(configcat.LogLevel.Info);
    this.configCatClient = configcat.getClient(
      environment.configCat,
      configcat.PollingMode.AutoPoll,
      {
        setupHooks: (hooks) =>
          hooks.on('flagEvaluated', (evaluationDetails) => {
            analyticsService.trackUnified('experiment_started', {
              legacy_event_name: '$experiment_started',
              'Experiment name': evaluationDetails.key,
              'Variant name': evaluationDetails.value,
              'Variation ID': evaluationDetails.variationId,
            });
            analyticsService.setProfileParameters({
              ['configcat_' + evaluationDetails.key]: evaluationDetails.value,
            });
          }),
        logger: this.logger,
      }
    );
    this.userInfo = {
      ...accountService.userInfo,
      identifier: accountService.userInfo?.userId,
    };
  }

  getExperimentFlag(flagName: string, defaultValue: boolean): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.configCatClient
        .getValueAsync(flagName, defaultValue, this.userInfo)
        .then((value) => {
          this.experimentArray[flagName] = value;
          resolve(value);
        })
        .catch((error) => {
          console.error('Error getting feature flag value:' + flagName, error);
          resolve(defaultValue);
        });
    });
  }
}
